import React, { useState, useEffect } from 'react';
import { Vehicle } from 'core/models/vehicle';
import { VehicleCameraLayout, MainScreenLayout } from 'core/models/layout';
import { useCameraLayoutRepository } from './useCameraLayoutRepository';
import { LayoutUpdateListener } from 'core/repositories/CameraLayoutRepository';

export function useCameraLayout(vehicleId: Vehicle.Id): [VehicleCameraLayout, React.Dispatch<VehicleCameraLayout>] {
    const layoutRepository = useCameraLayoutRepository();

    const [layout, setLayout] = useState(layoutRepository.get(vehicleId));

    useEffect(() => {
        const listener: LayoutUpdateListener = layout => setLayout(layout);
        layoutRepository.addListener(vehicleId, listener);
        return () => layoutRepository.removeListener(vehicleId, listener);
    }, [layoutRepository, vehicleId]);

    return [layout, layout => {
        layoutRepository.set(vehicleId, layout);
    }];
}

export function useMainScreenLayout(vehicleId: Vehicle.Id): [MainScreenLayout] {
    const layoutRepository = useCameraLayoutRepository();

    const [layout, setLayout] = useState(layoutRepository.get(vehicleId));

    useEffect(() => {
        const listener: LayoutUpdateListener = layout => setLayout(layout);
        layoutRepository.addListener(vehicleId, listener);
        return () => layoutRepository.removeListener(vehicleId, listener);
    }, [layoutRepository, vehicleId]);

    return [layout.mainscreen];
}
